<template>
  <div class="col-12">

    <div class="row">
      <div class="col-9">

        <p class="" v-if="pathwayLists.length == 0 && loading == false">No pathways setup on account.</p>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>

        <div class="">
          <div class="d-flex flex-wrap">
            <div class="d-flex flex-column" v-for="(pathway, index) in pathwayLists">
            <div class="pathway_box" :style="'border-left: 7px solid ' 
            + pathway.ascentColor + ' !important;'">
              <p class="font-weight-bold pb-2">{{ pathway.pathwayName }}</p>
              <p class="flex-grow-1" style="min-height: 80px;">{{ truncate(pathway.pathwayDescription) }}</p>
              <div class="row">
                <div class="col">
                  <p><a @click="showPathwayStep(pathway.id)" style="cursor: pointer; color: #00ACEE;">Show Pathway</a></p>
                </div>
                <div class="col text-right">
                  <b-dropdown id="dropdown-2" text="..." class="m-md-2" style="margin: 0 !important; margin-top: -8px !important;">
                    <b-dropdown-text><a class="dropdown-item1 bold" @click="editPathwayStep(pathway.id)">Edit</a></b-dropdown-text>
                    <b-dropdown-text><a class="dropdown-item1 bold" @click="clonePathwayStep(pathway.id)">Duplicate</a></b-dropdown-text>
                    <b-dropdown-text><a class="dropdown-item1 bold" @click="editPathwayAction(pathway)">Rename</a></b-dropdown-text>
                    <b-dropdown-text  v-if="pathway.status == 'DRAFT'"><a class="dropdown-item1 bold" @click="updatePathwayStatus(pathway.id, 'PUBLISH')">Publish</a></b-dropdown-text>
                    <b-dropdown-text ><a class="dropdown-item1 bold" @click="openLogFullListModal(pathway.id)">View History</a></b-dropdown-text>
                    <b-dropdown-text v-if="pathway.status == 'PUBLISH'"><a class="dropdown-item1 bold" @click="openAssignAccountsListModal(pathway.id)">Assign</a></b-dropdown-text>
                  </b-dropdown>


                </div>
              </div>
            </div>
            </div>


          </div>
        </div>
      </div>

      <div class="col-3 text-right p-0">
        <button class="btn btn-red btn-md input-height-15 rounded"
          @click="isModalVisible = true; this.verrors.clear();">New Pathway</button>
      </div>
    </div>


    <CreatePathwayModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <div slot="header" class="sub-heading" style="margin: 0;"><h5 style="color : #002F42">Create new pathway</h5></div>
      <div slot="body" v-if="isModalVisible == true">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding form-group">
            <label for="pathway_name">Name <span class="required">*</span></label>
            <input v-model="pathway_name"
                  name="pathway_name"
                  placeholder="Name the new pathway"
                  class="col-lg-12 input-text form-control"
                  style="line-height: 30px; "
                  v-validate="'required'"
                  maxlength="140" />
            <div v-if="verrors.firstByRule('pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
          </div>
          <div class="col-12 override-padding form-group">
            <label for="pathway_description">Description</label>
            <textarea
              name="pathway_description" 
              v-model="pathway_description"
              placeholder="Describe the new pathway"
              class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25 form-control"
              maxlength="500" style="resize: none; height: 80px;">
              </textarea>
          </div>
          <div class="col-12 override-padding form-group">
            <label class="col-12 p-0 " for="pathway_description">Accent color</label>
            <div class="ascent-color-main" v-for="(color) in ascent_color">
              <div v-if="color == colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
                <div class="ascent-color1" :style="'background-color: '+ color"  @click="updateColor(color)"></div>  
              </div>
              <div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateColor(color)"></div>
            </div>

            <i class="fa fa-plus-circle" @click="togglePicker()" style="cursor: pointer; font-size: 17px; margin-top: 2px;"></i>
          </div>

          <div class="col-12 override-padding form-group">
            <Sketch :value="colors" @input="updateFromPicker" v-show="displayPicker" class="vc-left" />
          </div>

        </div>
      </div>
      <div slot="footer" class="col-3 p-0 text-right">
        <button type="submit" class="btn btn-red btn-lg input-height-15 rounded pathway_save_btn" style="width: 60%; height: 40px;" @click="createPathway()">Save</button>
      </div>
    </CreatePathwayModal>


    <EditPathwayModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
      <div slot="header" class="sub-heading" style="margin: 0;"><h5 style="color : #002F42">Edit pathway</h5></div>
      <div slot="body" v-if="isEditModalVisible == true">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding form-group">
            <label for="pathway_name">Name <span class="required">*</span></label>
            <input v-model="edit_pathway_name"
                  name="edit_pathway_name"
                  placeholder="Name the new pathway"
                  class="col-lg-12 input-text form-control"
                  style="line-height: 30px; "
                  v-validate="'required'"
                  maxlength="140" />
            <div v-if="verrors.firstByRule('edit_pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
          </div>
          <div class="col-12 override-padding form-group">
            <label for="pathway_description">Description</label>
            <textarea
              name="edit_pathway_description" 
              v-model="edit_pathway_description"
              placeholder="Describe the new pathway"
              class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25 form-control"
              maxlength="500" style="resize: none; height: 80px;">
              </textarea>
          </div>
          <div class="col-12 override-padding form-group">
            <label class="col-12 p-0 " for="pathway_description">Accent color</label>
            <div class="ascent-color-main" v-for="(color) in edit_ascent_color">
              <div v-if="color == edit_colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
                <div class="ascent-color1" :style="'background-color: '+ color"  @click="updateEditColor(color)"></div>  
              </div>
              <div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateEditColor(color)"></div>
            </div>

            <i class="fa fa-plus-circle" @click="togglePicker()" style="cursor: pointer; font-size: 17px; margin-top: 2px;"></i>
          </div>

          <div class="col-12 override-padding form-group">
            <Sketch :value="edit_colors" @input="updateEditFromPicker" v-show="displayPicker" class="vc-left" />
          </div>

        </div>
      </div>
      <div slot="footer" class="col-3 p-0 text-right">
        <button type="submit" class="btn btn-red btn-lg input-height-15 rounded pathway_save_btn" style="width: 60%; height: 40px;" @click="editPathway()">Save</button>
      </div>
    </EditPathwayModal>



    <AssignAccounts :isModalVisible="isAssignAccountsListVisible" @close="isAssignAccountsListVisible = false">
      <div slot="header" class="sub-heading" style="margin: 0;"><h5 style="color : #002F42">Choose Accounts</h5></div>
      <div slot="body" v-if="isAssignAccountsListVisible == true">
        <div class="col-12 override-padding">

          <div class="clearfix"></div>
          <div class="col-12 resources_lists" v-for="(item, aindex) in accounts" :key="aindex">
              <div class="res_offcanvas_content res_heading_1 text-left">
              <div class="chkboxwrapper">
                <div class="custom-control custom-checkbox">
                  <input 
                      type="checkbox" 
                      :name="'account_' + item.id"
                      :id="'account_' + item.id"
                      :value="item.id"
                      v-model="accountsSelected"
                      :checked="item.checked" 
                      @click="getAccountSelected(item, aindex, $event)" 
                      class="custom-control-input">
                  <label class="custom-control-label" :for="'account_' + item.id"></label>
                  {{ item.name }}
                </div>
              </div>
              </div>
          </div>

          <div class="col-12 override-padding form-group">
            <Sketch :value="edit_colors" @input="updateEditFromPicker" v-show="displayPicker" class="vc-left" />
          </div>

        </div>
      </div>
      <div slot="footer" class="col-12 p-0 text-center">
        <button type="submit" class="btn btn-red btn-lg input-height-15 rounded pathway_save_btn" style="width: 20%; height: 40px;" @click="onSubmit()">Save</button>
      </div>
    </AssignAccounts>


    <LogFullList 
      :isModalVisible="isLogFullListVisible"
      @closeLogFullListModal="closeLogFullListModal"
      ref="LogFullListModal">
    </LogFullList>


  </div>




</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import CreatePathwayModal from '../admin/create-tasklist-modal.vue';
import EditPathwayModal from '../admin/create-tasklist-modal.vue';
import ColourPicker from 'vue-colour-picker';
import { Sketch } from 'vue-color'
//import 'bootstrap/js/dist/dropdown.js';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import LogFullList from '@/components/admin/pathway_audit_log_full_list.vue';
import AssignAccounts from '../admin/create-tasklist-modal.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        props: ['accountId'],
        data() {
          return {
            isModalVisible: false,
            isEditModalVisible: false,
            pathway_name: '',
            pathway_description: '',
            displayPicker: false,
            colors: '#2EACEE',
            ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            pathwayLists: [],
            loading: false,
            edit_pathway_name: '',
            edit_pathway_id: '',
            edit_pathway_description: '',
            edit_colors: '#2EACEE',
            edit_ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            isLogFullListVisible: false,
            isAssignAccountsListVisible: false,
            accounts: [],
            accountsSelected: [],
            accountsModified: [],
            accountsRemoved: [],
            pathwayId: '',
          }
        },
        components: {
          CreatePathwayModal,
          ColourPicker,
          Sketch,
          EditPathwayModal,
          LogFullList,
          AssignAccounts,
        },
        methods: {
          getAccountSelected(item, index, event) {
            if(event.target.checked == true) {
               this.accountsSelected.push(event.target.value);
               this.accountsModified.push(event.target.value);
            }
            else {
              const removeItemIndex = this.accountsSelected.indexOf(event.target.value);
              this.accountsRemoved.push(event.target.value);
              if(removeItemIndex > -1) {
                this.accountsSelected.splice(removeItemIndex, 1); 
              }
            }
          },
          onSubmit() {
            axios('/enterprise-admin/assign-account-pathway',
            {
              method: 'POST',
              data: {
                'accountsSelected': this.accountsModified,
                'accountsRemoved': this.accountsRemoved,
                'account_id': this.accountId,
                'pathway_id': this.pathwayId,
              }
            })
            .then(response => {
              this.closeAssignAccountsListModal();
            })
            .catch(() => {
            });
          },
          getAccounts(pathwayId) {
            this.pathwayId = pathwayId;
            this.accounts = [];
            const params = {};
            params.accountId = this.accountId;
            params.pathwayId = this.pathwayId;
            axios.get('/desktop/v2/get-enterprise-accounts/pathway-assign', {
              params: params
            })
            .then(response =>  {
              let data = response.data;
              this.loading = false;
              this.accounts = data.accounts;
              this.accountsSelected = data.assigned_accounts;
            })
            .catch(function() {});
          },
          openAssignAccountsListModal(pathwayId) {
            this.getAccounts(pathwayId);
            this.isAssignAccountsListVisible = true;
          },
          closeAssignAccountsListModal() {
            this.accountsModified = [];
            this.accountsSelected = [];
            this.accountsRemoved = [];
            this.pathwayId = '';
            this.isAssignAccountsListVisible = false;
          },

          openLogFullListModal(pathwayId) {
            this.$refs.LogFullListModal.getActivityData(pathwayId, this.accountId);
            this.isLogFullListVisible = true;
          },
          closeLogFullListModal() {
            this.isLogFullListVisible = false;
          },
          truncate: function (text) {
            if (text.length > 150) {
                return text.substring(0, 150) + '...';
            } else {
                return text;
            }
          },
          updatePathwayStatus(id, status_text) {
            axios('/edit-pathway/' + id,
             {
               method: 'PATCH',
               data: { "status": status_text},
             }
            )
            .then((resp) => {
              this.getPathwayLists();
            })
            .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
            });
          },
          editPathwayAction(pathway) {
            this.edit_pathway_id = pathway.id;
            this.edit_pathway_name = pathway.pathwayName;
            this.edit_pathway_description = pathway.pathwayDescription;
            this.edit_colors = pathway.ascentColor;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.isEditModalVisible = true;
          },
          editPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/edit-pathway/' + this.edit_pathway_id,
                 {
                   method: 'PATCH',
                   data:
                    {
                      pathway_name: this.edit_pathway_name,
                      pathway_description: this.edit_pathway_description,
                      ascent_color: this.edit_colors,
                    },
                 }
               )
              .then((resp) => {
                  this.getPathwayLists();
                  this.isEditModalVisible = false;
                  this.edit_pathway_name = '';
                  this.edit_pathway_description = '',
                  this.displayPicker = '',
                  this.edit_pathway_id = '';
                  this.edit_colors = '#2EACEE';
                  this.edit_ascent_color = [];
                  this.edit_ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          clonePathwayStep: function(pathwayId) {
            this.loading = true;
            axios('/clone-pathway/' + pathwayId,
              {
                method: 'POST',
              }
            )
            .then((resp) => {
               this.getPathwayLists();
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
            
          },
          showPathwayStep: function(pathwayId) {
            this.$store.dispatch('pathway_steps', '');
            this.$parent.showPathwayStepTab(pathwayId);
          },
          editPathwayStep: function(pathwayId) {
            this.$store.dispatch('pathway_steps', '');
            this.$parent.selectPathwayStepTab(pathwayId);
          },
          createPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/create-pathway',
                 {
                   method: 'POST',
                   data:
                    {
                      pathway_name: this.pathway_name,
                      pathway_description: this.pathway_description,
                      ascent_color: this.colors,
                      accountId: this.accountId,
                    },
                 }
               )
              .then((resp) => {
                  this.getPathwayLists();
                  this.isModalVisible = false;
                  this.pathway_name = '';
                  this.pathway_description = '',
                  this.displayPicker = '',
                  this.colors = '#2EACEE';
                  this.ascent_color = [];
                  this.ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          getPathwayLists() {
            this.pathwayLists = [];
            this.loading = true;
            axios('/get-pathway',
               {
                 method: 'GET',
                 params: {
                   account_id: this.accountId,
                 }
               }
             )
            .then((resp) => {
                this.loading = false;
                this.pathwayLists = resp.data;
             })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          showPicker() {
            document.addEventListener('click', this.documentClick);
            this.displayPicker = true;
          },

          hidePicker() {
            document.removeEventListener('click', this.documentClick);
            this.displayPicker = false;
          },
          togglePicker() {
            this.displayPicker ? this.hidePicker() : this.showPicker();
          },
          updateFromPicker(color) {
            this.colors = color.hex;
            if(this.ascent_color.indexOf(this.colors) === -1) {
              this.ascent_color.push(this.colors);
            }
            this.displayPicker = false;
          },
          updateColor(color) {
            this.colors = color;
          },
          updateEditFromPicker(color) {
            this.edit_colors = color.hex;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.displayPicker = false;
          },
          updateEditColor(color) {
            this.edit_colors = color;
          },

        },
        created() {
          this.getPathwayLists();
        },
}
</script>
<style scoped>
.pathway_box {
  border-color: lightgray !important;
  border-left: 7px solid #00ACEE !important;
  border-radius: 7px !important;
  background-color: white !important;
  padding: 8px 10px 5px 10px;
  margin-bottom: 25px;
}

.pathway_box p {
  margin-bottom: 3px;
}

.d-flex div.pathway_box {
  margin-right: 15px;
  width: 275px;
  background-color: burlywood;
}

.pathway_box .dropdown button {
  margin-top: -10px;
}

.pathway_box .dropdown button:focus {
  box-shadow: unset;
}

.accent_color_add {
  height: 23px;
  width: 23px;
  display: inline-flex;
  background-color: #e9e9e9;
  color: #646e71;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.pathway_save_btn {
  padding: 5px 10px !important;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 400;
}

</style>
<style >
.vc-sketch {
    position: absolute !important;
    top: -260px !important;
    left: 50px !important;
}
.ascent-color {
  height: 15px;
  width: 15px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color1 {
  height: 12px;
  width: 12px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color-main {
  float: left;
  margin-right: 10px;
}
.ascent-color-outer {
  float: left;
  padding: 0px 2px 2px 2px;
  border-radius: 15px;
  margin-top: 1px;
}
.dropdown-item {
  cursor: pointer;
  color: #BBB !important;
}
#dropdown-2 .dropdown-toggle::after{
  display: none;
}
#dropdown-2 .dropdown-toggle {
  background: none;
  border: 0;
  color: #002F42;
  font-weight: bold;
}
#dropdown-2 .dropdown-menu {
  margin: 0px;
  padding: 0px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 110px;
}
#dropdown-2 .b-dropdown-text {
  margin-bottom: 0px;
}
#dropdown-2 .b-dropdown-text {
  cursor: pointer;
  color: #BBB !important;
  padding: 2px 5px 2px 10px;
  font-size: 14px;
}
#dropdown-2.dropdown a, #dropdown-2.dropdown a:hover {
  font-size: 15px;
  color: #BBB !important;
  font-weight: bold;
}
#dropdown-2 .dropdown-item:hover, #dropdown-2 .dropdown-item:active, #dropdown-2 .dropdown-item:focus, #dropdown-2.dropdown a:hover, #dropdown-2.dropdown a:focus, #dropdown-2.dropdown a:active {
  background: none !important;
  text-decoration: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_pathway_list_tab.vue